import React from 'react';

type CloseButtonProps = {
  onClick?: () => void;
};

export default function CloseButton({ onClick }: CloseButtonProps) {
  return (
    <button
      type="button"
      className="btn-close"
      aria-label="Close"
      onClick={onClick}
    />
  );
}
